import setCarePlanMedications from './setCarePlanMedications';
import addCarePlanMedications from './addCarePlanMedications';
import updateCarePlanMedication from './updateCarePlanMedication';
import removeCarePlanMedication from './removeCarePlanMedication';

export default {
  setCarePlanMedications,
  addCarePlanMedications,
  updateCarePlanMedication,
  removeCarePlanMedication,
};
